import { uniqId } from "utils/helpers/uniq-id";

export const download = (dataUrl: string, filename = uniqId()) => {
  const a = document.createElement("a");
  a.href = dataUrl;
  a.download = filename;
  a.click();
};
